var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXxl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 58,
    viewBox: "0 0 54 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.8536V24.3472L23.6173 36.4933V57.9997L0 45.8536Z",
    fill: "url(#paint0_linear_2934_6000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9384 43.6822V22.1758L23.6172 36.4391V57.9455L53.9384 43.6822Z",
    fill: "url(#paint1_linear_2934_6000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3478L30.3827 10.0845L54 22.2306L23.5558 36.4382L0 24.3478Z",
    fill: "url(#paint2_linear_2934_6000)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9471 36.3828L9.65552 36.8286V37.4414L11.1931 36.8843V39.8929L11.6851 40.1715V37.1628L13.1612 39.4472V38.8343L11.8081 36.8843L10.9471 36.3828Z",
    fill: "#36A94C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4626 47.4694L26.5081 48.1937L27.1231 47.9151L25.8931 47.1351L28.5992 45.8536V45.4079L25.8931 46.6894L27.1847 44.6836L26.5696 44.9622L25.4626 46.6894V47.4694Z",
    fill: "#36A94C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8471 33.7077L50.8631 32.9834L50.3711 33.2063L51.5396 34.042L49.141 35.1563V35.602L51.5396 34.4877L50.3711 36.3821L50.8631 36.1592L51.8471 34.4877V33.7077Z",
    fill: "#36A94C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3942 44.5177L8.54913 43.5148V43.292L9.53319 42.7905C9.6562 42.7348 9.77921 42.6791 9.84071 42.5677C9.90222 42.5119 9.90222 42.4005 9.90222 42.2891C9.90222 42.1219 9.84071 42.0105 9.7792 41.8991C9.7177 41.7876 9.59469 41.6762 9.41018 41.5648C9.34868 41.5091 9.28718 41.509 9.22568 41.509C9.16417 41.509 9.10268 41.509 9.04117 41.509C8.91817 41.5648 8.91816 41.6762 8.91816 41.8433L8.54913 41.6762C8.54913 41.4533 8.61063 41.2862 8.79514 41.2305C8.91815 41.2305 9.04116 41.2305 9.16417 41.2305C9.28718 41.2305 9.41018 41.2862 9.47169 41.3419C9.7177 41.4533 9.90221 41.6762 10.0867 41.8433C10.2097 42.0105 10.3327 42.2334 10.3327 42.4562C10.3327 42.7348 10.1482 42.9019 9.7792 43.0691L9.04117 43.4591L10.4557 44.2391V44.5177H10.3942Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9926 45.3528L11.6236 45.13V42.9013L10.8856 42.7342V42.3999L11.9311 42.6228L11.9926 42.6785V45.3528Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 45.7424C14.8838 45.8538 14.8838 46.0209 14.8838 46.1324C14.8223 46.2438 14.7607 46.3552 14.6992 46.4667C14.5762 46.5781 14.3302 46.5781 14.0227 46.411C13.7152 46.2438 13.4692 46.021 13.3462 45.7981C13.1617 45.5195 13.1002 45.1852 13.1002 44.8509V44.4052C13.1002 44.2937 13.1002 44.1266 13.1002 44.0152C13.1617 43.9037 13.2232 43.7923 13.2847 43.6809C13.4077 43.5694 13.6537 43.6251 13.9612 43.7366C14.2687 43.9037 14.5147 44.1266 14.6377 44.3495C14.8222 44.628 14.8838 44.9623 14.8838 45.2966V45.7424ZM14.5147 45.0738C14.5147 44.8509 14.4532 44.628 14.3917 44.4052C14.3302 44.238 14.1457 44.0709 13.9612 44.0152C13.7767 43.9037 13.6537 43.9037 13.5307 44.0152C13.4692 44.1266 13.4077 44.2937 13.4692 44.5166V45.0738C13.4692 45.2966 13.5307 45.5752 13.5922 45.7981C13.6537 45.9652 13.8382 46.1324 14.0227 46.2438C14.2072 46.3552 14.3302 46.3552 14.4532 46.2438C14.5762 46.0767 14.6378 45.9095 14.5763 45.7424L14.5147 45.0738Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5837 24.069V23.4561V23.679L29.5222 23.7347V23.7904L29.2762 24.0133L28.9687 24.2361L28.5382 24.459L28.0461 24.5704L27.4926 24.6261L26.9391 24.5704L26.3856 24.459L25.8935 24.2918L25.586 24.069C25.6475 23.9018 25.6475 23.7904 25.6475 23.7347C25.6475 23.679 25.094 23.4004 25.094 23.4004V24.5704C25.094 24.5704 25.2785 24.9604 25.709 25.1833L25.7706 25.239L25.9551 25.2947L26.0165 25.3504L26.3856 25.4619L26.9391 25.5176L27.4926 25.5733L28.0461 25.5176L28.5382 25.4062H28.5997L28.8457 25.3504L28.9072 25.2947L29.0302 25.239L29.0917 25.1833L29.3377 25.0162V24.9604L29.5222 24.7376V24.5704L29.5837 24.4033V24.069Z",
    fill: "#B2C9B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8814 18.3867L18.2664 18.6653L17.8973 20.6154L18.5124 20.2811L18.8814 18.3867Z",
    fill: "#B2C9B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5121 23.2337L18.5736 23.1223V22.8994V22.6766V22.4537V22.3423V22.2865V22.2308V20.2808L17.9586 20.6151V23.4566V23.5123L18.5121 23.2337Z",
    fill: "#B2C9B6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5698 18.665L26.5083 18.9993L25.8932 19.3336C25.8317 19.1108 25.6472 18.9993 25.4627 18.8322C25.2167 18.7207 25.0937 18.7765 24.9092 18.8879L18.5743 22.1751V23.178L17.9593 23.5123C17.8978 23.2895 17.7133 23.1223 17.4673 23.0109C17.0982 22.8437 16.8522 22.9552 16.8522 23.3452C16.8522 23.7352 17.0982 24.1252 17.4673 24.2924C17.5288 24.3481 17.6518 24.3481 17.7133 24.3481L17.7748 24.4038L17.9593 24.3481L18.6358 24.0138L26.6313 19.8351C26.8158 19.7794 26.8773 19.6679 26.8773 19.4451C26.8158 19.1108 26.6928 18.8322 26.5698 18.665Z",
    fill: "url(#paint3_linear_2934_6000)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3441 23.0669C16.9751 22.8998 16.7291 23.0112 16.7291 23.4012C16.7291 23.7355 16.9751 24.1812 17.3441 24.3484C17.7132 24.5155 17.9592 24.4041 17.9592 24.0141C17.9592 23.6241 17.7132 23.2341 17.3441 23.0669Z",
    fill: "url(#paint4_linear_2934_6000)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2209 23.2892C16.9749 23.1777 16.7903 23.2335 16.7903 23.512C16.7903 23.7349 16.9749 24.0692 17.2209 24.1806C17.4669 24.292 17.6514 24.2363 17.6514 23.9578C17.6514 23.7349 17.4669 23.4006 17.2209 23.2892Z",
    fill: "url(#paint5_linear_2934_6000)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3577 14.3184L47.2962 14.4855V14.5412L47.0501 14.8198L46.6811 15.0427L46.1891 15.2098L45.6356 15.3212H45.0205L44.467 15.2655L43.9135 15.1541L43.3599 14.9312V15.4884V16.0456L43.9135 16.2684L44.467 16.3798L45.0205 16.4356H45.6356L46.1891 16.3241L46.6196 16.157H46.6811L47.0501 15.9341L47.2962 15.7113V15.6555L47.3577 15.377V14.8198V14.3184Z",
    fill: "url(#paint6_linear_2934_6000)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7833 21.9519L28.7218 21.5062V21.2833V21.1719L28.8448 20.1133L27.6147 20.7262L27.9838 21.339L27.9223 21.3947L27.8607 21.4505L27.9223 21.5062H27.9838L28.0452 21.5619L28.1068 21.6176V21.6733V21.729L27.8607 21.8962L27.7992 22.2305L28.1683 22.1748L28.4143 22.1191L28.1683 22.2862L28.8448 22.5091V22.4533V22.0076V21.9519H28.7833Z",
    fill: "#98AD9D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4349 13.483C46.4349 13.8173 45.9428 14.0959 45.3278 14.0959C44.7128 14.0959 44.2208 13.8173 44.2208 13.483C44.2208 13.1487 44.7128 12.8701 45.3278 12.8701C45.9428 12.8701 46.4349 13.1487 46.4349 13.483Z",
    fill: "#F9F9F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3058 20.559L30.8137 20.8933L29.7067 21.5062H29.3376V21.9519L30.4447 21.3947L30.8752 21.1719L32.3513 20.3919H32.4128V20.1133L31.3058 20.559Z",
    fill: "#B2C9B6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7838 21.9521H28.9069H29.2759V21.5063H28.7224L28.7838 21.9521Z",
    fill: "#B2C9B6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8454 20.2799L28.7838 20.5585L28.7224 21.1714V21.5057H29.2759H29.6449V19.6113L28.8454 20.2799Z",
    fill: "#98AD9D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4898 17.9962L31.4283 18.0519L31.3053 18.1077V18.0519V17.9962L30.6288 18.1634L30.0753 18.9991L30.3213 19.222V19.3334L30.2598 19.3891L29.7062 19.6677V21.5621L30.8133 20.9492L31.3053 20.5592L32.3509 20.1134L33.1504 19.7791V17.3276L31.4898 17.9962Z",
    fill: "#98AD9D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.34 5.46043L25.094 5.23756V5.18185L24.9709 4.95898V5.46043V5.96187L25.0325 6.18474L25.094 6.29617L25.2785 6.51903L25.7705 6.7419V6.51903V6.24045V5.68329L25.34 5.46043Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4508 16.3252L19.0658 16.5481L18.2663 18.721L17.8973 20.6711V23.5126L17.7743 23.2897L17.6513 23.1783L17.4667 23.0669L17.3437 23.0111H17.1592L17.0977 23.0669V20.1696L17.4052 18.2753L18.1433 16.3809H18.4508V16.3252Z",
    fill: "url(#paint7_linear_2934_6000)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8247 16.046L10.3326 16.2689L9.77912 16.3246L9.16409 16.3803L8.61056 16.3246L8.54905 16.2689L8.05703 16.2131V16.1574L7.74951 16.046L8.42605 16.3803L8.48754 16.436L8.54905 16.4917L8.91807 16.5474L9.22559 16.6032H9.59462L9.96364 16.5474L10.2097 16.4917L10.2712 16.436L11.1322 16.1574V15.9346L10.8247 16.046Z",
    fill: "#98AD9D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5329 21.9526L37.1479 21.674L36.7789 19.3896L36.1639 19.7239L36.5329 21.9526Z",
    fill: "#B2C9B6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4709 24.9049L37.0244 24.682L37.0859 24.6263V24.5706V24.3477V24.292V24.1806V21.6733L36.4094 22.0076V24.9049H36.4709Z",
    fill: "#B2C9B6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7996 28.4713L27.9226 28.527L28.1071 28.5827L28.2301 28.6941L28.4146 28.8055L28.4761 28.9727L28.5376 29.0284V26.1312L27.9226 25.7969L27.7381 25.8526L27.6766 25.9083V28.5827L27.7996 28.4713Z",
    fill: "#98AD9D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1644 19.7233L36.7794 19.389L35.9799 16.436L35.3649 16.6589L36.1644 19.7233Z",
    fill: "#B2C9B6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2387 15.9902L39.3002 16.2131H43.4825V15.9902H39.2387Z",
    fill: "#B2C9B6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1891 16.3255L45.6356 16.4369H45.0205L44.467 16.3812L43.9135 16.2697L43.3599 16.0469V16.2697L44.344 16.5483L44.713 16.604L45.0205 16.6598H45.4511L45.8201 16.604L46.0661 16.5483L46.6196 16.214L46.1891 16.3255Z",
    fill: "#B2C9B6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5222 23.3458L29.4607 23.0672L29.2762 22.8444L29.2147 22.7887L29.0302 22.6772L28.8457 22.6215H28.7842L28.7227 22.5658L28.6612 22.5101L28.2921 22.2315V22.2872L28.3536 22.3429L28.4152 22.3986C28.0461 22.2872 27.6771 22.1758 27.2466 22.1758C26.0165 22.1758 24.9709 22.6772 24.9709 23.3458C24.9709 24.0144 25.955 24.5159 27.2466 24.5159C27.3081 24.5159 27.3081 24.5159 27.3081 24.5159H27.3696H27.6156C27.6771 24.5159 27.6771 24.5159 27.7386 24.5159L27.9846 24.4601L28.4766 24.3487L28.9072 24.1258L29.2762 23.903L29.4607 23.6244V23.5687L29.5222 23.513V23.3458Z",
    fill: "url(#paint8_linear_2934_6000)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3988 4.84668L29.3373 5.06954V5.12526L29.0912 5.40384L28.7837 5.6267L28.4762 5.79385V6.29529V6.85246V6.90818L28.7222 6.74103H28.7837L29.0912 6.51816L29.3373 6.18386L29.3988 5.961V5.40384V4.84668Z",
    fill: "url(#paint9_linear_2934_6000)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0705 14.7646V15.2661V15.8233H15.2527V15.2661V14.7646H11.0705Z",
    fill: "#B2C9B6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5581 16.6031L19.0661 16.4917L18.2665 18.6646L18.8816 18.386L19.5581 16.6031Z",
    fill: "#B2C9B6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0158 22.0078L26.0773 21.5063H25.5238V21.9521H25.9543L26.0158 22.0078Z",
    fill: "#98AD9D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1705 18.163L23.371 17.8844V18.1073L23.3095 18.0516L23.125 17.9958L21.4644 17.2158V19.6673L22.2024 20.0016L23.371 20.5031L23.8015 20.7816L25.0316 21.506L25.0931 19.333L24.1705 18.163Z",
    fill: "url(#paint10_linear_2934_6000)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0323 21.5063L23.8022 20.782L23.3717 20.5591L22.1416 20.002V20.2805L22.2031 20.3363H22.2646L22.3261 20.392L22.4491 20.4477L22.6951 20.5591L22.9411 20.6706L23.1256 20.782L23.3717 20.8934L23.6177 21.0049L23.8022 21.0606L23.8637 21.1163H23.9252L23.9867 21.172L24.9707 21.6734L25.0938 21.7292H25.1553L25.4013 21.8963H25.4628V21.4506H25.0323V21.5063Z",
    fill: "url(#paint11_linear_2934_6000)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0165 21.3945L25.5245 19.7787L25.0325 19.333L24.9709 21.5059H25.4015H25.955V21.3945H26.0165Z",
    fill: "#98AD9D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3349 17.0492L32.0433 17.6621L31.4898 17.9963L33.1504 17.3278L33.3349 17.2163L34.6265 16.882L35.303 16.6592L35.9795 16.4363L36.041 16.3806V16.1577L33.3349 17.0492Z",
    fill: "#B2C9B6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.239 14.9326V15.4898L39.1775 15.9912L43.4212 16.0469V15.4898V14.9326H39.239Z",
    fill: "url(#paint12_linear_2934_6000)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5381 25.5178L27.9845 25.6292L27.431 25.6849H26.8775L26.3239 25.5735L25.9549 25.4621L26.5084 25.7407L26.7544 25.7964L27.1235 25.8521H27.431H27.677L27.7385 25.7964L27.923 25.7407L28.1075 25.6849L28.169 25.6292L28.4765 25.5178L28.7841 25.2949L28.5381 25.5178Z",
    fill: "#B2C9B6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1638 19.7236L35.3642 16.6592L34.6877 16.882L35.3642 19.2778L36.1638 19.7236Z",
    fill: "#98AD9D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0912 25.2397L29.0297 25.2955L28.8452 25.3512L28.7837 25.4069L28.4762 25.6298L28.5377 26.1312L29.1527 25.8526L29.0912 25.2397Z",
    fill: "#98AD9D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1686 25.7408L27.9227 25.7965L28.5377 26.1308L28.4762 25.6294L28.1686 25.7408Z",
    fill: "#98AD9D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5989 29.0275L29.1524 28.7489V28.6932V28.5818V28.3589V28.136V27.9132V27.8017V27.6903V27.6346V25.7402L28.5374 26.0188L28.5989 29.0275Z",
    fill: "#B2C9B6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6106 21.506L36.4716 22.0075L36.5331 21.9518L36.1641 19.7231L35.303 19.2217L35.6106 21.506Z",
    fill: "#98AD9D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6104 24.4036H35.6719L35.7334 24.3479H35.8564L36.0409 24.4036L36.2254 24.4593L36.3484 24.6265L36.4714 24.7936V24.8493V21.9521L35.6104 21.5063V24.4036Z",
    fill: "#98AD9D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 14.7643L10.8243 14.9315L10.3323 15.0986L9.77875 15.2101H9.16372L8.6102 15.1544L8.05667 15.0429L7.62614 14.8201L7.31862 14.5972V14.5415L7.13412 14.3186L7.07262 14.2629L7.01111 14.04V14.6529V15.0986L7.07262 15.2101L7.13412 15.3772L7.25712 15.6001L7.62614 15.8229L7.68765 15.8787L7.74915 15.9344L8.05667 16.0458V16.1015L8.54869 16.1572L8.6102 16.213L9.16372 16.2687L9.77875 16.213L10.3323 16.1572L10.7628 15.9901L10.8243 15.9344L11.0703 15.7672V15.2101V14.7643Z",
    fill: "url(#paint13_linear_2934_6000)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0414 15.1555V16.2141L39.2397 15.9912L39.3012 14.9326L36.0414 15.1555Z",
    fill: "#36A94C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0403 15.1543L33.3342 15.99L32.0426 16.6029L30.751 17.2715L29.152 18.6644V18.7201V18.7758L28.9059 19.6673L29.0904 19.5559L29.152 19.5001L30.013 18.943L30.0745 18.9987L30.628 18.553L30.8125 18.3301L31.3661 18.0515L31.4276 17.9958L31.4891 17.9401H31.5506L32.1041 17.6058L33.3957 16.9929L36.1018 16.1572V15.6V15.1543H36.0403Z",
    fill: "url(#paint14_linear_2934_6000)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6308 5.01388L26.0773 4.51244L25.9543 4.34529L25.8927 4.17814V3.95528L25.9543 3.78813L26.1388 3.73242L25.4622 4.06671L25.2162 4.28958L24.9702 4.56816L24.9087 4.62387V4.90245V4.95817L24.9702 5.18103V5.23675L25.2162 5.45961H25.2777L25.7082 5.73819V6.29535V6.57393V6.7968V7.57682V7.68825V7.96683V8.02255L25.3392 9.52688L24.0476 10.6969L24.6626 10.3069L26.1388 8.96972L26.2002 8.85829L26.6308 7.24252H26.6923L26.6308 5.01388Z",
    fill: "url(#paint15_linear_2934_6000)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2529 14.7646V15.8233L18.4511 16.0461V14.9875L15.2529 14.7646Z",
    fill: "#2C973C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0414 16.2131V16.4359L39.2396 16.2131L39.1781 15.9902L36.0414 16.2131Z",
    fill: "#2C973C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5859 18.7764V18.7207L23.9253 17.3278L22.5107 16.6035L21.1576 15.8792L18.4515 15.0435V15.6006V16.1021L21.1576 16.9378H21.2191L22.5722 17.6621H22.6337L22.6952 17.7178L22.7567 17.7735H22.8182L22.8797 17.8293H22.9412V17.885H23.0028L23.0642 17.9407H23.1257L23.1873 17.9964H23.2487V18.0521H23.3103L23.3718 18.1078L23.4948 18.1636L24.1713 18.4979L24.3558 18.665L25.2784 19.445L25.7704 19.8908L26.2624 21.5065V21.0051V20.5036L25.5859 18.7764Z",
    fill: "url(#paint16_linear_2934_6000)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9681 9.58378L28.5376 7.91229V6.85368V6.79797V6.24081V5.73936L28.8452 5.57221L29.1527 5.34934L29.3987 5.07076V5.01505L29.4602 4.79218V4.73647L29.3987 4.45789L28.6606 4.12359L28.5991 4.06787L28.5376 4.23502L28.4761 4.40217L28.2301 4.56932L27.6766 5.01505V7.18798L28.1686 8.80375L28.2916 8.91519L29.6447 10.2524L30.3827 10.6981L28.9681 9.58378Z",
    fill: "#B2C9B6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0637 17.9404L23.0022 17.8847H22.9407L22.8792 17.829H22.8176V17.7733H22.7562L22.6947 17.7175L22.6331 17.6618L22.5717 17.6061H22.5101L21.1571 16.8818H21.0956L18.4509 16.1018L15.2527 15.8789H11.0705V16.1018H15.2527L18.0819 16.3246H18.4509L19.0659 16.5475L19.558 16.6589L21.2186 17.1604L21.4031 17.2161L23.0637 17.9404Z",
    fill: "#98AD9D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2529 13.6504V14.8204L18.4511 15.0433V13.8733L15.2529 13.6504Z",
    fill: "#36A94C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0704 13.6508L10.2094 13.9293L9.96338 13.9851L9.59436 14.0408H9.28684H8.91781L8.6103 13.9293L8.42579 13.8736L8.17976 13.7065L8.11828 13.5393L8.05677 13.3722L8.11828 13.2607L7.93375 13.3165L7.68774 13.3722V13.4279L7.50324 13.4836L7.25721 13.7065L7.19572 13.7622L7.13422 13.9851V14.0408L7.19572 14.2636L7.25721 14.3193L7.44173 14.5422V14.5979L7.74925 14.8208L8.17976 15.0437L8.73331 15.1551L9.28684 15.2108H9.90187L10.4554 15.0994L10.9474 14.9322L11.1935 14.7651H15.3757V13.595H11.0704V13.6508Z",
    fill: "url(#paint17_linear_2934_6000)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4469 17.996L24.9708 16.5474L23.1873 15.5445L21.2191 14.6531L18.4515 13.873V15.0431L21.1576 15.8788L22.5107 16.6031L23.9253 17.3275L25.5859 18.7204V18.7761L26.0164 20.3918V20.8933V21.3947V21.5619V22.0076L26.1394 21.8962L26.693 21.6733V21.6176L26.7545 21.5619L26.8775 21.3947V19.7232L26.4469 17.996Z",
    fill: "url(#paint18_linear_2934_6000)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4511 13.8739V12.9824L15.2529 13.2053V13.651L18.4511 13.8739Z",
    fill: "#8ADB95"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11836 13.5388L8.17985 13.706L8.42588 13.8731L8.67189 13.9288L8.9794 14.0403H9.34843H9.65594L10.0249 13.9846L10.271 13.9288L11.132 13.6503H15.3142V13.2045L11.0705 13.1488L9.84044 12.7588L10.2095 13.6503L10.0249 13.7617L9.84044 13.8174L9.59443 13.8731L9.34843 13.9288L9.04091 13.8731L8.79488 13.8174L8.61038 13.7617L8.42588 13.6503L8.36437 13.5388L8.42588 13.4274L8.48736 13.2602L8.30286 13.0374H8.24135L8.17985 13.0931L8.05685 13.316H7.99534L7.93384 13.4274L8.11836 13.5388Z",
    fill: "#F9F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0913 13.4274V13.0931H28.9682C28.9067 12.9817 28.7222 12.8702 28.5992 12.7588C27.8612 12.3688 26.6311 12.3688 25.9546 12.7588C25.7701 12.8145 25.6471 12.9817 25.5856 13.0931H25.4626V13.4831C25.4626 13.706 25.6471 13.9846 26.0161 14.1517C26.7541 14.5417 27.9842 14.5417 28.6607 14.1517C28.9682 13.9846 29.1528 13.706 29.0913 13.4274Z",
    fill: "#B2C9B6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5984 13.8172C29.3364 13.4272 29.2749 12.8144 28.5984 12.4243C27.8603 12.0343 26.6303 12.0343 25.9538 12.4243C25.2157 12.8144 25.2772 13.4272 25.9538 13.8172C26.6303 14.2073 27.8603 14.2073 28.5984 13.8172Z",
    fill: "#FAFAFA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M36.041 13.9287L33.2734 14.7645L31.4283 15.6002L29.7677 16.5474L28.2302 17.996L28.1686 18.0517V18.2189L27.7996 19.6118V20.3918L28.3531 20.0575L28.9067 19.7232L29.1527 18.8317V18.776V18.7203L30.7518 17.3274L32.0433 16.6588L33.3349 16.0459L36.041 15.2102V13.9287Z",
    fill: "url(#paint19_linear_2934_6000)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2396 13.7612L36.0414 13.9841V15.1541L39.2396 14.9313V13.7612Z",
    fill: "#36A94C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3575 14.1522C47.3575 13.6508 46.8655 13.2607 46.2504 13.2607C45.6969 13.2607 45.2049 13.595 45.1434 14.0408H45.4509L45.6969 13.9851L45.8814 13.9293L46.0659 13.8179L46.1274 13.7622V13.6508L46.4349 13.7622L46.2504 13.8736L46.0659 13.9851L45.8199 14.0408L45.4509 14.0965H45.1434H45.0818L44.8358 14.0408L44.5283 13.9851L43.5443 13.6508H39.3005V14.8208L43.5443 14.8765L44.0363 15.0994L44.5898 15.2108L45.1434 15.2665L45.6969 15.2108L46.2504 15.1551L46.7424 14.988L47.1114 14.7651L47.173 14.7094C47.2345 14.6537 47.296 14.5979 47.3575 14.4865L47.419 14.4308L47.4805 14.3751C47.3575 14.2636 47.419 14.2079 47.3575 14.1522L47.419 14.0965V14.0408C47.3575 14.2079 47.3575 14.2079 47.3575 14.1522Z",
    fill: "url(#paint20_linear_2934_6000)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2397 13.7614L39.3012 13.3156H39.2397L36.0414 13.0928V13.9842L39.2397 13.7614Z",
    fill: "#8ADB95"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28.169 18.2749V18.1078L28.2305 18.052L29.7681 16.6034L31.3672 15.6005L33.2738 14.7648L36.0414 13.9848V13.0933L33.2738 12.3133L31.3057 11.3661L30.3216 10.7532L29.6451 10.3632L28.2305 9.02604L28.169 8.97033L27.6155 7.29885V5.12591L28.169 4.68018L28.415 4.51304L28.4765 4.34589L28.5381 4.17874L28.169 3.95588V4.17874L28.1075 4.23446V4.29017L27.923 4.4016L27.8615 4.45732L27.7385 4.51304L27.6155 4.62447H27.554L27.308 4.68018H27.062L26.8159 4.62447L26.5699 4.56875L26.4469 4.51304L26.3854 4.45732L26.3239 4.4016V4.34589L26.2624 4.29017H26.2009V4.17874H26.1394V4.01159L26.4469 3.62158L25.9549 3.84444L25.8934 4.01159V4.23446L25.9549 4.4016L26.0779 4.56875L26.6314 5.12591L26.693 7.29885L26.2624 8.91461L26.1394 9.02604L24.7248 10.3632L24.0483 10.7532L23.1257 11.3104L21.2191 12.1461L18.4515 12.9262V13.8733L21.2191 14.6534L23.1872 15.5448L24.9093 16.6034L26.4469 18.052L26.8775 19.6678V21.395L26.9389 21.3393L27.0005 21.2836L27.062 21.2279L27.1234 21.1164L27.2465 21.0607L27.308 20.7264L27.431 20.615L27.6155 20.5593L27.677 20.5035L27.6155 19.7235L28.169 18.2749ZM27.2465 14.3748L26.7544 14.3191L26.3239 14.2634L25.9549 14.1519L25.7089 13.9848L25.6474 13.9291L25.4629 13.7062V13.5948L25.4014 13.4833V13.2605V13.2048L25.4629 12.9819L25.7089 12.759L25.7704 12.7033L26.0164 12.5362H26.0779H26.1394L26.3239 12.4804L26.5699 12.4247C26.939 12.2576 27.431 12.2576 28.1075 12.4247H28.169L28.5381 12.5919L28.784 12.759L28.8456 12.8147L29.0301 13.0376L29.0916 13.0933L29.1531 13.3162V13.3719V13.539L29.0916 13.7619V13.8176L28.8456 13.9291V13.9848L28.5995 14.2076L28.2305 14.3191L27.8 14.4305H27.2465V14.3748Z",
    fill: "url(#paint21_linear_2934_6000)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4209 13.7615L44.405 14.0958L44.7125 14.1515L45.02 14.2073H45.0815V14.1515C45.0815 14.0958 45.0815 14.0958 45.0815 14.0401H44.8355L44.5895 13.9844L44.3435 13.9287L44.2205 13.8172V13.7058V13.6501L44.4665 13.5944L44.897 12.9258L43.4209 13.4272H39.2387V13.873L43.4209 13.7615Z",
    fill: "url(#paint22_linear_2934_6000)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1441 14.1519H45.4516L45.7591 14.0962L46.0051 13.9848L46.2512 13.8733L46.3742 13.7062L46.0667 13.5947V13.6504L46.0051 13.7062L45.8206 13.8176L45.6361 13.8733L45.3901 13.929H45.1441C45.1441 14.0405 45.1441 14.0962 45.1441 14.1519Z",
    fill: "#F9F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.524 1.72719L23.4329 0C23.8019 0 24.0479 0.0557176 24.1094 0.167149L26.385 1.50433L25.9545 1.72719H25.524Z",
    fill: "#576779"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4009 1.83862L23.3098 0.11143L23.3713 0H23.4328L25.5239 1.72719L25.4009 1.83862Z",
    fill: "#2C343D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5857 1.83885L25.8932 1.61598L26.3237 1.44884L26.6928 1.3374L26.8773 1.50455L25.7702 1.95028L25.5857 1.83885Z",
    fill: "#414D5B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5853 1.83897V1.89468L25.4008 1.83897L25.4623 1.72754L25.5853 1.83897Z",
    fill: "#2C343D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4471 1.95056L26.5086 2.1177L25.7706 1.95056L26.8776 1.56055L27.0007 2.00627L26.5701 1.95056H26.4471Z",
    fill: "#414D5B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4468 2.1174L26.3853 2.22883L25.7087 2.00597L25.7703 1.89453L26.4468 2.1174Z",
    fill: "#2C343D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8928 1.67139L25.5853 1.89425L25.5238 1.78282L25.8928 1.67139Z",
    fill: "#576779"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7702 1.95025L25.7087 2.06168L25.5857 1.95025V1.89453L25.7702 1.95025Z",
    fill: "#2C343D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0454 4.23387V4.01101H27.9224C27.8609 3.95529 27.8609 3.95529 27.7379 3.89957C27.3689 3.67671 26.7539 3.67671 26.3848 3.89957C26.3233 3.95529 26.2618 3.95529 26.2003 4.01101H26.0773V4.28959C26.0773 4.40102 26.2003 4.51245 26.3848 4.62388C26.7539 4.84674 27.3689 4.84674 27.7379 4.62388C27.9839 4.51245 28.0454 4.40102 28.0454 4.23387Z",
    fill: "url(#paint23_linear_2934_6000)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7996 3.62076C27.4306 3.3979 26.8155 3.3979 26.4465 3.62076C26.0775 3.84362 26.0775 4.12221 26.4465 4.34507C26.8155 4.56793 27.4306 4.56793 27.7996 4.34507C28.1686 4.17792 28.1686 3.84362 27.7996 3.62076Z",
    fill: "#FAFAFA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8607 3.95618V2.78613H26.3846V4.01189C26.3846 4.0676 26.4461 4.23475 26.6306 4.29047C26.8767 4.45762 27.3687 4.45762 27.6147 4.29047C27.7377 4.17904 27.8607 4.06761 27.8607 3.95618Z",
    fill: "url(#paint24_linear_2934_6000)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6151 2.45202C27.3691 2.28487 26.8771 2.28487 26.631 2.45202C26.385 2.61917 26.385 2.84204 26.631 3.00918C26.8771 3.17633 27.3691 3.17633 27.6151 3.00918C27.8611 2.84204 27.8611 2.61917 27.6151 2.45202Z",
    fill: "url(#paint25_linear_2934_6000)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4921 2.34041C27.2461 2.22898 26.8771 2.22898 26.631 2.34041C26.385 2.45184 26.385 2.67471 26.631 2.78614C26.8771 2.89757 27.2461 2.89757 27.4921 2.78614C27.7381 2.67471 27.7381 2.50756 27.4921 2.34041Z",
    fill: "url(#paint26_linear_2934_6000)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8153 2.50792C26.8768 2.45221 26.9999 2.39648 27.0614 2.39648C27.1844 2.39648 27.3074 2.45221 27.3074 2.50792H27.3689V2.56364C27.3689 2.61935 27.2459 2.78651 27.0614 2.78651C26.8769 2.78651 26.7538 2.73079 26.7538 2.56364L26.8153 2.50792Z",
    fill: "#B2C9B6"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4465 2.00586C26.4465 2.06158 26.4465 2.06158 26.4465 2.00586C26.4465 2.06158 26.4465 2.06158 26.4465 2.00586C26.4465 2.06158 26.4465 2.06157 26.508 2.06157L27.3076 2.56302C27.3691 2.61874 27.6151 2.61873 27.7381 2.61873C27.7381 2.61873 27.7381 2.61873 27.7996 2.61873C27.7996 2.61873 27.8611 2.61874 27.8611 2.56302V2.78588C27.8611 2.8416 27.7996 2.8416 27.7996 2.89731C27.7996 2.89731 27.7996 2.89731 27.7381 2.89731C27.6151 2.95303 27.3691 2.95304 27.3076 2.8416L26.508 2.34015C26.4465 2.28444 26.4465 2.28444 26.4465 2.22872V2.00586Z",
    fill: "url(#paint27_linear_2934_6000)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8611 2.50744C27.7996 2.56315 27.7996 2.56315 27.8611 2.50744C27.8611 2.56315 27.8611 2.56315 27.8611 2.50744C27.7996 2.56315 27.7996 2.56316 27.7996 2.56316C27.7996 2.56316 27.7996 2.56316 27.7381 2.56316C27.6151 2.61887 27.3691 2.61887 27.3076 2.50744L26.508 2.006C26.508 2.006 26.4465 2.00599 26.4465 1.95028C26.4465 1.89456 26.508 1.89456 26.508 1.83885C26.508 1.83885 26.508 1.83885 26.5695 1.83885C26.6926 1.78313 26.9386 1.78312 27.0001 1.89456L27.7381 2.39601C27.7996 2.45172 27.8611 2.50744 27.8611 2.50744Z",
    fill: "#FAFAFA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8153 2.22912C26.8768 2.1734 26.9999 2.11768 27.0614 2.11768C27.1844 2.11768 27.3074 2.1734 27.3074 2.22912H27.3689V2.28483C27.3689 2.34054 27.2459 2.5077 27.0614 2.5077C26.8769 2.5077 26.7538 2.45198 26.7538 2.28483L26.8153 2.22912Z",
    fill: "#B2C9B6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7538 2.22877C26.7538 2.28449 26.9384 2.39592 27.0614 2.39592C27.2459 2.39592 27.3689 2.3402 27.3689 2.17305C27.3689 2.11734 27.2459 1.9502 27.0614 1.9502C26.9384 2.06163 26.7538 2.11734 26.7538 2.22877Z",
    fill: "#FAFAFA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2458 3.06428L27.1843 2.84142V2.72998L27.3074 3.06428V3.12L27.2458 3.06428Z",
    fill: "#2C343D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4313 3.23155L27.3698 3.17583V3.12012L27.6158 3.28726L27.5543 3.34297L27.4313 3.23155Z",
    fill: "#2C343D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4923 3.34283L27.5538 3.28711L27.6153 3.73283L27.4923 3.34283Z",
    fill: "#2C343D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28.599 2.8418L27.861 3.51038L27.6765 3.73324L27.5535 3.28752L28.599 2.8418Z",
    fill: "#414D5B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M28.661 2.78613L28.784 2.84185L27.8615 3.45473L28.661 2.78613Z",
    fill: "#414D5B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5989 2.84195L27.5534 3.28768L27.3074 3.12053L28.4144 2.6748H28.4759L28.5989 2.84195Z",
    fill: "#414D5B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2462 2.78541L27.3692 2.72969H27.4922H27.5537L27.7382 2.61826L27.7997 2.56255V2.50684L28.4147 2.72969L27.3077 3.17542L27.2462 2.78541Z",
    fill: "#414D5B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3824 4.95798H30.3209L27.7377 3.73223L27.9223 3.50936L28.8448 2.89648L28.9063 2.9522L28.9678 3.00791L29.1523 3.17507V3.23078L30.8744 4.84655L30.5054 4.95798H30.3824Z",
    fill: "#576779"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5058 4.95898L30.5673 5.0147L30.4443 5.07042L30.3828 4.95898H30.5058Z",
    fill: "#2C343D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8134 4.84668L30.8749 4.90239L30.5059 5.01381V4.95811L30.8134 4.84668Z",
    fill: "#2C343D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3833 4.95898L30.445 5.07075L30.3216 5.01487V4.95898H30.3833Z",
    fill: "#2C343D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3528 4.12243L28.1068 4.011L28.0452 3.95528L27.8607 3.84385H27.7992L27.6147 3.73242H27.6762L30.2594 4.95817V5.01388L29.3368 4.62387L29.2138 4.56816L28.3528 4.12243Z",
    fill: "#2C343D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6057 10.9762L41.5145 9.24902C41.8835 9.24902 42.1295 9.30473 42.191 9.41616L44.4667 10.7533L44.0362 10.9762H43.6057Z",
    fill: "#576779"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5444 11.0877L41.4533 9.41617L41.5148 9.24902H41.5763L43.6059 10.9762L43.5444 11.0877Z",
    fill: "#2C343D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6673 11.0873L44.0363 10.9202L44.4668 10.6973L44.8358 10.6416L45.0203 10.753L43.8518 11.1987L43.6673 11.0873Z",
    fill: "#414D5B"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6679 11.087V11.1427L43.5449 11.087L43.6064 10.9756L43.6679 11.087Z",
    fill: "#2C343D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5281 11.2553V11.4225L43.8516 11.1996L45.0202 10.7539L45.1432 11.1996L44.7126 11.1439L44.5281 11.2553Z",
    fill: "#414D5B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5284 11.4221L44.4669 11.4778L43.7903 11.2549V11.1992L44.5284 11.4221Z",
    fill: "#2C343D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0366 10.9756L43.6676 11.087L43.6061 10.9756H44.0366Z",
    fill: "#576779"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8518 11.2546V11.3103L43.6673 11.1988V11.0874L43.8518 11.2546Z",
    fill: "#2C343D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1888 13.539V13.3162H46.0659C46.0044 13.2605 46.0043 13.2605 45.8813 13.2047C45.5123 12.9819 44.8973 12.9819 44.5283 13.2047C44.4668 13.2605 44.4052 13.2605 44.3437 13.3162H44.2208V13.5947C44.2208 13.7062 44.3438 13.8176 44.5283 13.929C44.8973 14.1519 45.5123 14.1519 45.8813 13.929C46.0658 13.7619 46.1888 13.6505 46.1888 13.539Z",
    fill: "url(#paint28_linear_2934_6000)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8819 12.9261C45.4513 12.759 44.8363 12.759 44.5288 12.9261C44.1598 13.149 44.1598 13.4276 44.5288 13.6504C44.8978 13.8733 45.5128 13.8733 45.8819 13.6504C46.2509 13.4833 46.2509 13.149 45.8819 12.9261Z",
    fill: "url(#paint29_linear_2934_6000)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M45.943 13.2599V12.0898H44.4669V13.3156C44.4669 13.3713 44.5284 13.5384 44.7129 13.5942C44.959 13.7613 45.451 13.7613 45.697 13.5942C45.8815 13.4827 45.943 13.3713 45.943 13.2599Z",
    fill: "url(#paint30_linear_2934_6000)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6967 11.7557C45.4507 11.5886 44.9587 11.5886 44.7126 11.7557C44.4666 11.9229 44.4666 12.1457 44.7126 12.3129C44.9587 12.48 45.4507 12.48 45.6967 12.3129C46.0042 12.09 46.0042 11.8672 45.6967 11.7557Z",
    fill: "url(#paint31_linear_2934_6000)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5737 11.6451C45.3277 11.5337 44.9587 11.5337 44.7126 11.6451C44.4666 11.7565 44.4666 11.9794 44.7126 12.0908C44.9587 12.2023 45.3277 12.2023 45.5737 12.0908C45.8197 11.9237 45.8197 11.7565 45.5737 11.6451Z",
    fill: "url(#paint32_linear_2934_6000)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9588 11.8121C45.0203 11.7564 45.1434 11.7007 45.2049 11.7007C45.3279 11.7007 45.4509 11.7564 45.4509 11.8121H45.5124V11.8678C45.5124 11.9235 45.3894 12.0907 45.2049 12.0907C45.0203 12.0907 44.8973 12.035 44.8973 11.8678L44.9588 11.8121Z",
    fill: "url(#paint33_linear_2934_6000)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5281 11.3105C44.5281 11.3663 44.5281 11.3663 44.5281 11.3105C44.5281 11.3663 44.5281 11.3663 44.5896 11.3663L45.3892 11.8677C45.5122 11.9234 45.6967 11.9234 45.8197 11.9234C45.8197 11.9234 45.8197 11.9234 45.8812 11.9234C45.8812 11.9234 45.9427 11.9234 45.9427 11.8677V12.0906C45.9427 12.1463 45.8812 12.1463 45.8812 12.202C45.8812 12.202 45.8812 12.202 45.8197 12.202C45.6967 12.2577 45.4507 12.2577 45.3892 12.1463L44.7126 11.5334C44.6511 11.4777 44.6511 11.4777 44.6511 11.422V11.3105H44.5281Z",
    fill: "url(#paint34_linear_2934_6000)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9427 11.8117C45.8812 11.8674 45.8812 11.8674 45.8812 11.8674C45.8812 11.8674 45.8812 11.8674 45.8197 11.8674C45.6967 11.9231 45.4507 11.9231 45.3892 11.8117L44.5896 11.3102C44.5896 11.3102 44.5281 11.3102 44.5281 11.2545C44.5281 11.1988 44.5896 11.1988 44.5896 11.143C44.5896 11.143 44.5896 11.143 44.6511 11.143C44.7741 11.0873 45.0201 11.0873 45.0817 11.1988L45.8812 11.7002C45.9427 11.7002 45.9427 11.7559 45.9427 11.8117Z",
    fill: "#FAFAFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9588 11.5333C45.0203 11.4776 45.1434 11.4219 45.2049 11.4219C45.3279 11.4219 45.4509 11.4776 45.4509 11.5333H45.5124V11.589C45.5124 11.6447 45.3894 11.8119 45.2049 11.8119C45.0203 11.8119 44.8973 11.7562 44.8973 11.589L44.9588 11.5333Z",
    fill: "url(#paint35_linear_2934_6000)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8973 11.5334C44.8973 11.5891 45.0203 11.7563 45.2049 11.7563C45.3894 11.7563 45.5124 11.7006 45.5124 11.5334C45.5124 11.4777 45.3894 11.3105 45.2049 11.3105C45.0203 11.3663 44.8973 11.422 44.8973 11.5334Z",
    fill: "#FAFAFA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3899 12.3685L45.3284 12.1456V12.0342L45.5129 12.3685L45.4514 12.4242L45.3899 12.3685Z",
    fill: "#2C343D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5123 12.5353L45.4508 12.4239L45.5123 12.3682L45.6968 12.5353L45.6353 12.591L45.5123 12.5353Z",
    fill: "#2C343D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5739 12.5918L45.7584 12.9818L45.6969 13.0375L45.5739 12.5918Z",
    fill: "#2C343D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6813 12.0898L45.9433 12.7584L45.7588 12.9813L45.6357 12.5356L46.6813 12.0898Z",
    fill: "#414D5B"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7426 12.0898L46.8041 12.1456L45.9431 12.7584L46.7426 12.0898Z",
    fill: "#414D5B"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6809 12.0905L45.6353 12.5362L45.4508 12.3691L46.5579 11.9233L46.6193 11.9791L46.6809 12.0905Z",
    fill: "#414D5B"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2665 12.0344H45.4511L45.5741 11.9787H45.6356L45.8816 11.8673L45.9431 11.8116V11.7559L46.6196 11.923L45.4511 12.3687L45.2665 12.0344Z",
    fill: "#414D5B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M48.465 14.2637L48.342 14.208L45.7589 12.9822L45.9434 12.7594L46.8044 12.1465L46.9274 12.2022L46.9889 12.2579L47.1734 12.4251V12.4808L48.8955 14.0408L48.5265 14.1523L48.465 14.2637Z",
    fill: "#576779"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5881 14.2075L48.6496 14.2632L48.4651 14.319V14.2632L48.5881 14.2075Z",
    fill: "#2C343D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9572 14.0967V14.1524L48.6496 14.2638L48.5881 14.2081L48.9572 14.0967Z",
    fill: "#2C343D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4648 14.2634V14.3193L48.3414 14.2634V14.2075L48.4648 14.2634Z",
    fill: "#2C343D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4969 13.3724L46.2509 13.261L46.1893 13.2053L46.0048 13.1496L45.9434 13.0939L45.7589 13.0381L45.8203 12.9824L48.4035 14.2082V14.2639L47.4809 13.8739L47.2964 13.8182L46.4969 13.3724Z",
    fill: "#2C343D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8858 10.9766L12.8539 9.36084C12.4849 9.36084 12.3003 9.41656 12.1773 9.47228L10.0247 10.7537L10.4552 10.9209L10.8858 10.9766Z",
    fill: "#576779"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8856 11.088L12.9152 9.47228L12.8537 9.36084L10.8856 10.9766V11.088Z",
    fill: "#2C343D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7632 11.0873L10.4556 10.9202L10.0251 10.753L9.71759 10.6416L9.53308 10.753L10.5787 11.1987L10.7632 11.0873Z",
    fill: "#414D5B"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7631 11.087V11.1427L10.8861 11.087L10.8246 10.9756L10.7631 11.087Z",
    fill: "#2C343D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96391 11.1996V11.4225L10.6404 11.1996L9.59488 10.7539L9.47186 11.1996L9.84089 11.1439L9.96391 11.1996Z",
    fill: "#414D5B"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9635 11.3659L10.025 11.4217L10.7015 11.1988L10.64 11.1431L9.9635 11.3659Z",
    fill: "#2C343D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4558 10.9204L10.7633 11.0876L10.8248 10.9761L10.4558 10.9204Z",
    fill: "#576779"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5789 11.1988L10.6404 11.2546L10.7634 11.1431V11.0874L10.5789 11.1988Z",
    fill: "#2C343D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2716 13.3716V13.1487H10.1486C10.0871 13.093 10.0871 13.093 10.0256 13.0373C9.65654 12.8144 9.04152 12.8144 8.734 13.0373C8.6725 13.093 8.67249 13.093 8.61099 13.1487H8.48798V13.4273C8.48798 13.5387 8.611 13.6502 8.734 13.7616C9.10302 13.9844 9.71804 13.9844 10.0256 13.7616C10.1486 13.6502 10.2716 13.5387 10.2716 13.3716Z",
    fill: "url(#paint36_linear_2934_6000)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96384 12.8141C9.59482 12.5913 8.97979 12.5913 8.67227 12.8141C8.30325 13.037 8.30325 13.3156 8.67227 13.4827C9.04129 13.7056 9.65633 13.7056 9.96384 13.4827C10.2714 13.2599 10.3329 13.037 9.96384 12.8141Z",
    fill: "url(#paint37_linear_2934_6000)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0249 13.0934V11.9233H8.61035V13.1491C8.61035 13.2048 8.67185 13.372 8.85636 13.4277C9.10238 13.5948 9.53291 13.5948 9.84043 13.4277C9.96344 13.372 10.0249 13.2048 10.0249 13.0934Z",
    fill: "url(#paint38_linear_2934_6000)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84011 11.6449C9.5941 11.4777 9.16359 11.4777 8.85608 11.6449C8.61007 11.812 8.61007 11.9792 8.85608 12.1463C9.10208 12.3135 9.5326 12.3135 9.84011 12.1463C10.0861 12.0349 10.0861 11.812 9.84011 11.6449Z",
    fill: "url(#paint39_linear_2934_6000)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71752 11.5889C9.4715 11.4775 9.16399 11.4775 8.91797 11.5889C8.67196 11.7004 8.67196 11.9232 8.91797 12.0347C9.16399 12.1461 9.4715 12.1461 9.71752 12.0347C9.96354 11.8675 9.96354 11.7004 9.71752 11.5889Z",
    fill: "url(#paint40_linear_2934_6000)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59499 11.7008C9.53348 11.6451 9.47198 11.5894 9.34897 11.5894C9.22596 11.5894 9.10293 11.6451 9.10293 11.7008H9.04144V11.7565C9.04144 11.8122 9.16445 11.9236 9.34897 11.9236C9.53349 11.9236 9.6565 11.8679 9.6565 11.7565L9.59499 11.7008Z",
    fill: "url(#paint41_linear_2934_6000)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96342 11.2539C9.90192 11.3096 9.90192 11.3096 9.90192 11.3096L9.16387 11.8111C9.10237 11.8668 8.85637 11.8668 8.73336 11.8668C8.73336 11.8668 8.73336 11.8668 8.67186 11.8668C8.67186 11.8668 8.61035 11.8668 8.61035 11.8111V12.0339C8.61035 12.0896 8.67186 12.0896 8.67186 12.1454C8.67186 12.1454 8.67186 12.1454 8.73336 12.1454C8.85637 12.2011 9.04087 12.2011 9.16387 12.0896L9.90192 11.5882C9.96342 11.5325 9.96342 11.5325 9.96342 11.4768V11.2539Z",
    fill: "url(#paint42_linear_2934_6000)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61035 11.756C8.61035 11.8117 8.61035 11.8117 8.61035 11.756C8.61035 11.8117 8.67186 11.8117 8.67186 11.8117C8.67186 11.8117 8.67186 11.8117 8.73336 11.8117C8.85637 11.8674 9.04087 11.8674 9.16387 11.756L9.90192 11.2545C9.90192 11.2545 9.96342 11.2545 9.96342 11.1988C9.96342 11.1431 9.90192 11.1431 9.90192 11.0874C9.90192 11.0874 9.90191 11.0874 9.84041 11.0874C9.7174 11.0317 9.53289 11.0317 9.40988 11.1431L8.61035 11.6445C8.67185 11.6445 8.61035 11.6445 8.61035 11.756C8.61035 11.756 8.61035 11.7003 8.61035 11.756Z",
    fill: "#FAFAFA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59499 11.422C9.53348 11.3663 9.47198 11.3105 9.34897 11.3105C9.22596 11.3105 9.10293 11.3663 9.10293 11.422H9.04144V11.4777C9.04144 11.5334 9.16445 11.6449 9.34897 11.6449C9.53349 11.6449 9.6565 11.5891 9.6565 11.4777L9.59499 11.422Z",
    fill: "url(#paint43_linear_2934_6000)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34897 11.6449C9.53349 11.6449 9.6565 11.5891 9.6565 11.4777C9.6565 11.3663 9.53349 11.3105 9.34897 11.3105C9.16445 11.3105 9.04144 11.3663 9.04144 11.4777C9.04144 11.5334 9.16445 11.6449 9.34897 11.6449Z",
    fill: "#FAFAFA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16444 12.2576L9.22594 12.0348V11.9233L9.04144 12.2576L9.10293 12.3134L9.16444 12.2576Z",
    fill: "#2C343D"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04038 12.4249L9.10186 12.3692L9.04038 12.3135L8.8559 12.4806L8.91739 12.5364L9.04038 12.4249Z",
    fill: "#2C343D"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91771 12.5361L8.79468 12.8704L8.85619 12.9261L8.91771 12.5361Z",
    fill: "#2C343D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87262 12.0342L8.54916 12.7028L8.79517 12.8699L8.85667 12.4799L7.87262 12.0342Z",
    fill: "#414D5B"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81102 12.0342L7.74951 12.0899L8.61053 12.7027L7.81102 12.0342Z",
    fill: "#414D5B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87262 12.0353L8.85667 12.481L9.04119 12.3139L7.99563 11.8682L7.93413 11.9239L7.87262 12.0353Z",
    fill: "#414D5B"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22506 11.9231H9.10205H8.97905L8.91754 11.8674L8.67154 11.756L8.61003 11.7002V11.6445L7.995 11.8117L9.04056 12.2574L9.22506 11.9231Z",
    fill: "#414D5B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21189 14.0956L6.27339 14.0399L8.79501 12.8699L8.549 12.7027L7.68796 12.0898L7.62645 12.2013H7.56495L7.38045 12.3684V12.4241L5.71985 13.9285L6.08887 14.0399L6.21189 14.0956Z",
    fill: "#576779"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08873 14.04L6.02722 14.0958L6.15024 14.1515L6.21174 14.0958L6.08873 14.04Z",
    fill: "#2C343D"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71985 13.9287V13.9844L6.02736 14.0959L6.08887 14.0402L5.71985 13.9287Z",
    fill: "#2C343D"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21264 14.0959L6.15094 14.1518L6.27435 14.0959V14.04L6.21264 14.0959Z",
    fill: "#2C343D"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11822 13.2601L8.36423 13.1487L8.42574 13.093L8.61024 13.0373L8.67175 12.9815L8.91776 12.9258L8.85625 12.8701L6.33459 14.0402V14.0959L7.19566 13.7059L7.31866 13.6501L8.11822 13.2601Z",
    fill: "#2C343D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2622 8.85894L26.7542 7.24316H27.5537L28.0457 8.85894H26.2622Z",
    fill: "#36A94C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4008 9.52754L26.2618 8.85893L26.7539 7.24316L25.7698 7.96748L25.4008 9.52754Z",
    fill: "#8ADB95"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0455 8.85893L28.9681 9.58324L28.5376 7.91176L27.5535 7.24316L28.0455 8.85893Z",
    fill: "#2C973C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2098 24.1807L37.1484 24.515L36.5333 24.8493C36.4718 24.6264 36.2873 24.515 36.1028 24.3478C35.8568 24.2364 35.7338 24.2921 35.5492 24.4035L29.2144 27.6908V28.6937L28.5994 29.028C28.5379 28.8051 28.3534 28.638 28.1073 28.5265C27.7383 28.3594 27.4923 28.4708 27.4923 28.8608C27.4923 29.1951 27.7383 29.6408 28.1073 29.808C28.1688 29.8637 28.2918 29.8637 28.3533 29.8637L28.4149 29.9194L28.5994 29.8637L29.2759 29.5294L37.2713 25.3507C37.4558 25.295 37.5174 25.1835 37.5174 24.9607C37.4559 24.6264 37.3944 24.4035 37.2098 24.1807Z",
    fill: "url(#paint44_linear_2934_6000)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0461 28.5816C27.677 28.4144 27.431 28.5258 27.431 28.9158C27.431 29.2501 27.677 29.6959 28.0461 29.863C28.4151 30.0302 28.6611 29.9187 28.6611 29.5287C28.5996 29.1944 28.3536 28.7487 28.0461 28.5816Z",
    fill: "url(#paint45_linear_2934_6000)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8616 28.8609C27.6155 28.7495 27.431 28.8052 27.431 29.0838C27.431 29.3067 27.6155 29.641 27.8616 29.7524C28.1076 29.8638 28.2921 29.8081 28.2921 29.5295C28.2921 29.251 28.1076 28.9724 27.8616 28.8609Z",
    fill: "#47546A"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3689 22.0078C26.6924 22.0078 26.0773 22.3421 26.0773 22.6764C26.0773 23.0664 26.6308 23.345 27.3689 23.345C28.1069 23.345 28.6604 23.0107 28.6604 22.6764C28.6604 22.3421 28.0454 22.0078 27.3689 22.0078Z",
    fill: "#F9F9F9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9386 19.6685L26.4465 17.9971H28.2302L27.7996 19.6128L26.9386 19.6685Z",
    fill: "#36A94C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9388 19.6686L26.0162 20.3372L25.5857 18.6657L26.4467 17.9971L26.9388 19.6686Z",
    fill: "#8ADB95"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0158 20.3911V21.2826L25.9543 21.3383L25.5238 19.834L25.5853 18.7754L26.0158 20.3911Z",
    fill: "#8ADB95"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M29.152 18.7207V19.6122L28.9059 19.6679L29.152 18.7207Z",
    fill: "#2C973C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7996 19.6675L28.2302 18.0518L29.1527 18.7204L28.8452 19.8904L28.2916 20.1132L27.7996 19.6675Z",
    fill: "#2C973C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M28.968 20.3365L30.9361 18.7207C30.5671 18.7207 30.3211 18.7764 30.2596 18.8321L28.107 20.1136L28.5375 20.2807L28.968 20.3365Z",
    fill: "#576779"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9674 20.4479L30.9356 18.8321V18.7207H30.8741L28.9059 20.3365L28.9674 20.4479Z",
    fill: "#2C343D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8448 20.4477L28.5373 20.2805L28.1068 20.0577L27.7992 20.002L27.6147 20.1134L28.6603 20.5034L28.8448 20.4477Z",
    fill: "#414D5B"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8454 20.4478V20.5592L28.9684 20.5035L28.9069 20.3921L28.8454 20.4478Z",
    fill: "#2C343D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0458 20.559V20.7262L28.7224 20.5033L27.6153 20.1133L27.4923 20.559L27.8613 20.4476L28.0458 20.559Z",
    fill: "#414D5B"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0458 20.7267L28.1073 20.7824L28.7223 20.6153V20.5596L28.0458 20.7267Z",
    fill: "#2C343D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5374 20.2808L28.8449 20.4479L28.9064 20.3365L28.5374 20.2808Z",
    fill: "#576779"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6611 20.5596V20.6711L28.8457 20.5596V20.5039L28.6611 20.5596Z",
    fill: "#2C343D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3532 22.7876V22.5647H28.2302C28.1687 22.509 28.1687 22.509 28.1072 22.4533C27.7381 22.2304 27.1231 22.2304 26.8156 22.4533C26.7541 22.509 26.7541 22.509 26.6926 22.5647H26.5696V22.7876C26.5696 22.899 26.6926 23.0105 26.8156 23.1219C27.1846 23.3448 27.7997 23.3448 28.1072 23.1219C28.2302 23.0105 28.3532 22.899 28.3532 22.7876Z",
    fill: "url(#paint46_linear_2934_6000)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0454 22.175C27.6764 21.9521 27.0614 21.9521 26.7539 22.175C26.3849 22.3978 26.3849 22.6764 26.7539 22.8436C27.1229 23.0664 27.7379 23.0664 28.0454 22.8436C28.4145 22.6764 28.4145 22.3978 28.0454 22.175Z",
    fill: "url(#paint47_linear_2934_6000)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0447 22.5099V21.3398H26.6302V22.5099C26.6302 22.5656 26.6917 22.7328 26.8762 22.7885C27.1222 22.9556 27.5527 22.9556 27.8602 22.7885C28.0448 22.677 28.1062 22.6213 28.0447 22.5099Z",
    fill: "url(#paint48_linear_2934_6000)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8612 21.0599C27.6152 20.8928 27.1847 20.8928 26.8771 21.0599C26.6311 21.2271 26.6311 21.3942 26.8771 21.5614C27.1232 21.7285 27.5537 21.7285 27.8612 21.5614C28.1687 21.3942 28.1687 21.1714 27.8612 21.0599Z",
    fill: "url(#paint49_linear_2934_6000)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7998 20.9488C27.5538 20.8374 27.2463 20.8374 27.0002 20.9488C26.7542 21.0602 26.7542 21.2831 27.0002 21.3945C27.2463 21.506 27.5538 21.506 27.7998 21.3945C28.0458 21.2274 28.0458 21.0602 27.7998 20.9488Z",
    fill: "url(#paint50_linear_2934_6000)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6767 21.1158C27.6152 21.0601 27.5536 21.0044 27.4306 21.0044C27.3076 21.0044 27.1846 21.0601 27.1846 21.1158H27.1231V21.1715C27.1231 21.2273 27.2461 21.3387 27.4306 21.3387C27.6152 21.3387 27.7382 21.283 27.7382 21.1715L27.6767 21.1158Z",
    fill: "url(#paint51_linear_2934_6000)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0457 20.6147C28.0457 20.6147 28.0457 20.6705 28.0457 20.6147C28.0457 20.6705 28.0457 20.6705 28.0457 20.6147C28.0457 20.6705 28.0457 20.6705 28.0457 20.6147C27.9842 20.6705 27.9842 20.6705 27.9842 20.6705L27.2461 21.1719C27.1846 21.2276 26.9386 21.2276 26.8156 21.2276C26.8156 21.2276 26.8156 21.2276 26.7541 21.2276C26.7541 21.2276 26.6926 21.2276 26.6926 21.1719V21.3948C26.6926 21.4505 26.7541 21.4505 26.7541 21.5062C26.7541 21.5062 26.7541 21.5062 26.8156 21.5062C26.9386 21.5619 27.1231 21.5619 27.2461 21.4505L27.9842 20.949C28.0457 20.8933 28.0457 20.8933 28.0457 20.8376V20.6147Z",
    fill: "url(#paint52_linear_2934_6000)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6926 21.1163C26.6926 21.172 26.7541 21.1721 26.7541 21.1721C26.7541 21.1721 26.7541 21.1721 26.8156 21.1721C26.9386 21.2278 27.1231 21.2278 27.2461 21.1163L27.9842 20.6149C27.9842 20.6149 28.0457 20.6149 28.0457 20.5592C28.0457 20.5034 27.9842 20.5035 27.9842 20.4477C27.9842 20.4477 27.9842 20.4477 27.9227 20.4477C27.7997 20.392 27.6152 20.392 27.4922 20.5034L26.7541 21.0049C26.6926 21.0049 26.6926 21.0606 26.6926 21.1163Z",
    fill: "#FAFAFA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6767 20.8375C27.6152 20.7818 27.5536 20.7261 27.4306 20.7261C27.3076 20.7261 27.1846 20.7818 27.1846 20.8375H27.1231V20.8932C27.1231 20.9489 27.2461 21.0604 27.4306 21.0604C27.6152 21.0604 27.7382 21.0046 27.7382 20.8932L27.6767 20.8375Z",
    fill: "url(#paint53_linear_2934_6000)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6763 20.838C27.6763 20.8937 27.5532 21.0052 27.3687 21.0052C27.1842 21.0052 27.0612 20.9495 27.0612 20.838C27.0612 20.7266 27.1842 20.6709 27.3687 20.6709C27.5532 20.6709 27.6763 20.7266 27.6763 20.838Z",
    fill: "#FAFAFA"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2461 21.6741L27.3077 21.4513V21.3398L27.1231 21.6741V21.7299L27.2461 21.6741Z",
    fill: "#2C343D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1227 21.7848L27.1842 21.7291V21.6733L26.9382 21.8405L26.9997 21.8962L27.1227 21.7848Z",
    fill: "#2C343D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0003 21.8409L26.9388 21.7852L26.8157 22.2309L26.8773 22.2866L27.0003 21.8409Z",
    fill: "#2C343D"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9549 21.3945L26.6314 22.0074L26.8159 22.2303L26.8775 21.7845L25.9549 21.3945Z",
    fill: "#414D5B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8933 21.3945L25.8318 21.4503L26.6928 22.0631L25.8933 21.3945Z",
    fill: "#414D5B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9549 21.3947L26.9389 21.7847L27.185 21.6175L26.1394 21.2275H26.0779L25.9549 21.3947Z",
    fill: "#414D5B"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2459 21.3391L27.1228 21.2834H27.0614H26.9383L26.7538 21.1719L26.6924 21.1162L26.0773 21.2834L27.1228 21.6734L27.2459 21.3391Z",
    fill: "#414D5B"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M24.232 23.4565H24.355L26.8151 22.2864L26.6306 22.0636L25.7696 21.4507L25.6465 21.5064L25.585 21.5621L25.4005 21.7293L25.339 21.785L23.8015 23.345L24.109 23.4565H24.232Z",
    fill: "#576779"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1101 23.4561V23.5119L24.2335 23.5678V23.4561H24.1101Z",
    fill: "#2C343D"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8024 23.3447L23.7409 23.4004L24.1099 23.5119V23.4562L23.8024 23.3447Z",
    fill: "#2C343D"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2325 23.4561V23.5678L24.3559 23.5119V23.4561H24.2325Z",
    fill: "#2C343D"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1386 22.6767L26.3846 22.5653L26.4461 22.5095L26.6306 22.3981H26.6922L26.8767 22.3424L26.8151 22.231L24.355 23.4567V23.5124L25.2161 23.1224L25.3391 23.0667L26.1386 22.6767Z",
    fill: "#2C343D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M37.025 40.6715C37.7015 40.3372 38.132 40.5601 38.132 41.3401C38.132 42.0644 37.7015 42.9559 36.902 43.3459C36.1024 43.7359 35.6104 43.4016 35.6104 42.3987C35.6104 41.6187 35.8564 40.8944 36.2254 40.3372C36.533 39.8358 36.9635 39.4458 37.394 39.1672C37.517 39.0558 37.64 39.0001 37.763 38.9443V39.3901C37.763 39.3901 37.7015 39.3901 37.7015 39.4458C37.64 39.5015 37.517 39.5572 37.394 39.6129C36.5944 40.1701 36.2254 40.9501 36.1024 41.6187C36.3484 41.2287 36.656 40.8387 37.025 40.6715ZM36.9635 42.9002C37.394 42.6773 37.7015 42.1759 37.7015 41.6187C37.7015 41.0615 37.394 40.8944 36.9635 41.1173C36.6559 41.2844 36.41 41.6187 36.2254 41.953C36.1639 42.0087 36.1639 42.1201 36.1639 42.2316C36.1639 42.8445 36.4099 43.1787 36.9635 42.9002Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9773 39.1129C40.6539 38.7786 41.0844 39.0015 41.0844 39.7815C41.0844 40.5058 40.6539 41.3973 39.8543 41.7873C39.0548 42.1773 38.5627 41.843 38.5627 40.8401C38.5627 40.0601 38.8088 39.3358 39.1778 38.7786C39.4853 38.2772 39.9158 37.8872 40.3463 37.6086C40.4693 37.4972 40.5924 37.4415 40.7154 37.3857V37.8315C40.7154 37.8315 40.6539 37.8315 40.6539 37.8872C40.5924 37.9429 40.4693 37.9986 40.3463 38.0543C39.5468 38.6115 39.1778 39.3915 39.0548 40.0601C39.2393 39.7258 39.5468 39.3358 39.9773 39.1129ZM39.8543 41.3973C40.2848 41.1744 40.5924 40.673 40.5924 40.1158C40.5924 39.5587 40.2848 39.3915 39.8543 39.6144C39.5468 39.7815 39.3008 40.1158 39.1163 40.4501C39.0548 40.5058 39.0548 40.6173 39.0548 40.7287C39.0548 41.3416 39.3008 41.6759 39.8543 41.3973Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7449 36.2705C43.5444 35.8805 43.9749 36.382 43.9749 37.552C43.9749 38.8335 43.5444 39.8364 42.6834 40.2264C41.9453 40.6164 41.4533 40.1707 41.4533 38.8892C41.4533 37.6635 42.0068 36.7163 42.7449 36.2705ZM42.6834 39.8921C43.1754 39.6135 43.4214 38.8892 43.4214 37.8863C43.4214 36.9391 43.1754 36.4377 42.6834 36.7163C42.2529 36.9391 41.9453 37.6634 41.9453 38.722C41.9453 39.7249 42.2529 40.115 42.6834 39.8921Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2934_6000",
    x1: 17.7228,
    y1: 38.9236,
    x2: -1.48724,
    y2: 47.6724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2934_6000",
    x1: 50.79,
    y1: 42.3963,
    x2: 13.1393,
    y2: 33.4954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2934_6000",
    x1: 44.6097,
    y1: 31.4967,
    x2: -8.73901,
    y2: 1.08939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1927,
    stopColor: "#E9E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2934_6000",
    x1: 22.2738,
    y1: 21.9779,
    x2: 21.5462,
    y2: 20.5862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A566F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2934_6000",
    x1: 16.766,
    y1: 23.6887,
    x2: 17.9678,
    y2: 23.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A566F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2934_6000",
    x1: 16.7651,
    y1: 23.7483,
    x2: 17.6557,
    y2: 23.7483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A566F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2934_6000",
    x1: 43.4571,
    y1: 15.3625,
    x2: 47.3798,
    y2: 15.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2934_6000",
    x1: 17.361,
    y1: 19.8754,
    x2: 19.0898,
    y2: 19.8754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2934_6000",
    x1: 25.0466,
    y1: 23.3893,
    x2: 29.5517,
    y2: 23.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2934_6000",
    x1: 28.4823,
    y1: 5.8596,
    x2: 29.3772,
    y2: 5.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E1D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2934_6000",
    x1: 21.4152,
    y1: 19.3559,
    x2: 25.0451,
    y2: 19.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2934_6000",
    x1: 22.1637,
    y1: 20.9931,
    x2: 25.448,
    y2: 20.9931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2934_6000",
    x1: 39.231,
    y1: 15.4636,
    x2: 43.4618,
    y2: 15.4636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2934_6000",
    x1: 7.1335,
    y1: 15.2234,
    x2: 11.1097,
    y2: 15.2234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2934_6000",
    x1: 32.2622,
    y1: 16.745,
    x2: 33.2944,
    y2: 20.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D5E1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFCD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2934_6000",
    x1: 24.0845,
    y1: 7.23752,
    x2: 26.7286,
    y2: 7.23752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2934_6000",
    x1: 21.9701,
    y1: 17.2565,
    x2: 23.7584,
    y2: 22.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D5E1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFCD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2934_6000",
    x1: 7.1336,
    y1: 14.2452,
    x2: 26.9562,
    y2: 14.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2934_6000",
    x1: 23.4425,
    y1: 17.2439,
    x2: 17.9272,
    y2: 21.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E3F1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFCD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2934_6000",
    x1: 32.3213,
    y1: 16.2994,
    x2: 27.7491,
    y2: 20.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E3F1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFCD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2934_6000",
    x1: 27.7822,
    y1: 14.2057,
    x2: 47.3815,
    y2: 14.2057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2934_6000",
    x1: 18.4558,
    y1: 12.5083,
    x2: 36.0421,
    y2: 12.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2934_6000",
    x1: 39.2369,
    y1: 13.5264,
    x2: 45.159,
    y2: 13.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2934_6000",
    x1: 26.1308,
    y1: 4.24278,
    x2: 28.0719,
    y2: 4.24278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2934_6000",
    x1: 26.3742,
    y1: 3.58455,
    x2: 27.8257,
    y2: 3.58455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2934_6000",
    x1: 26.374,
    y1: 2.72615,
    x2: 27.8292,
    y2: 2.72615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2934_6000",
    x1: 26.4964,
    y1: 2.58612,
    x2: 27.6846,
    y2: 2.58612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2934_6000",
    x1: 26.4152,
    y1: 2.47945,
    x2: 27.8303,
    y2: 2.47945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2934_6000",
    x1: 44.2318,
    y1: 13.5468,
    x2: 46.1729,
    y2: 13.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2934_6000",
    x1: 44.2311,
    y1: 13.3067,
    x2: 46.1722,
    y2: 13.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2934_6000",
    x1: 44.4731,
    y1: 12.8871,
    x2: 45.9258,
    y2: 12.8871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2934_6000",
    x1: 44.4728,
    y1: 12.0287,
    x2: 45.9279,
    y2: 12.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2934_6000",
    x1: 44.5939,
    y1: 11.8501,
    x2: 45.7828,
    y2: 11.8501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2934_6000",
    x1: 44.9023,
    y1: 11.8695,
    x2: 45.5259,
    y2: 11.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2934_6000",
    x1: 44.5158,
    y1: 11.783,
    x2: 45.9298,
    y2: 11.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2934_6000",
    x1: 44.9023,
    y1: 11.5901,
    x2: 45.5259,
    y2: 11.5901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2934_6000",
    x1: 8.39326,
    y1: 13.3866,
    x2: 10.2624,
    y2: 13.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2934_6000",
    x1: 8.39243,
    y1: 13.1668,
    x2: 10.2627,
    y2: 13.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2934_6000",
    x1: 8.62573,
    y1: 12.7479,
    x2: 10.0243,
    y2: 12.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2934_6000",
    x1: 8.62729,
    y1: 11.929,
    x2: 10.0289,
    y2: 11.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2934_6000",
    x1: 8.74638,
    y1: 11.8096,
    x2: 9.89096,
    y2: 11.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2934_6000",
    x1: 9.01807,
    y1: 11.7699,
    x2: 9.61837,
    y2: 11.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2934_6000",
    x1: 8.62573,
    y1: 11.6824,
    x2: 9.98864,
    y2: 11.6824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2934_6000",
    x1: 9.01807,
    y1: 11.49,
    x2: 9.61837,
    y2: 11.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2934_6000",
    x1: 32.9089,
    y1: 27.5348,
    x2: 32.1813,
    y2: 26.1436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A566F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2934_6000",
    x1: 27.3978,
    y1: 29.2379,
    x2: 28.5996,
    y2: 29.2379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A566F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2934_6000",
    x1: 26.4521,
    y1: 22.7698,
    x2: 28.3212,
    y2: 22.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2934_6000",
    x1: 26.4513,
    y1: 22.5104,
    x2: 28.321,
    y2: 22.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2934_6000",
    x1: 26.6868,
    y1: 22.1316,
    x2: 28.0847,
    y2: 22.1316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2934_6000",
    x1: 26.6871,
    y1: 21.3118,
    x2: 28.0887,
    y2: 21.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2934_6000",
    x1: 26.804,
    y1: 21.1522,
    x2: 27.9492,
    y2: 21.1522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2934_6000",
    x1: 27.0757,
    y1: 21.1526,
    x2: 27.6748,
    y2: 21.1526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2934_6000",
    x1: 26.6852,
    y1: 21.066,
    x2: 28.0475,
    y2: 21.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2934_6000",
    x1: 27.0757,
    y1: 20.8732,
    x2: 27.6748,
    y2: 20.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9CFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXxl);
export default __webpack_public_path__ + "static/media/xxl.0772c9f804cda81d202ec293be6fe501.svg";
export { ForwardRef as ReactComponent };